export default __webpack_public_path__ + "static/media/rightArrow.6e0c2cad.svg";